// Auth actions
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ADDITEM = "ADDITEM";
export const REMOVEITEM = "REMOVEITEM";
export const RESETITEM = "RESETITEM";

